export const az = {
  title: 'Meşələrin bərpası üçün təbii meşə regrowth-dan karbon yığılma potensialı.',
  subtitle: 'reforestable areas, 1 km, Cook-Patton et al. 2020',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Funksiya',
      value: '1990-cı ilin 20-ci il hesablamalarına görə, 1000-dən çox bitkinin 1000-dən çox sahəsi var.',
    },
    {
      label: 'Qətmə',
      value: '1 × 1 km',
    },
    {
      label: 'Coğrafi əhatə',
      value:
        'Global, within reforestation extent of Griscom et al. 2017 (bu da boreal, ot biomes və croplands istisna edir)',
    },
    {
      label: 'Mənbə',
      value:
        'Cook-Patton, S.C., S.M. Leavitt, D. Gibbs, N.L. Harris, K. Lister, K.J. Anderson-Teixeira, R.D. Briggs, R.L. Chazdon, T.W. Crowther, P.W. Ellis, H.P. Griscom, V. Herrmann, K.D. Holl, R.A. Houghton, C. Larrosa, G. Lomax, R. Lucas, P. Madsen, Y. Malhi, A. Paquette, J.D. Parker, K. Paul, D. Routh, S. Roxburgh, S. Saatchi, J.van den Hoogen, W.S. Walker, C.E. Wheeler, S.A. Wood, L. Xu, B.W. Griscom. 2020. Mapping carbon accumulation potential from natural forest regrowth. Nature, in press. https://www.nature.com/articles/s41586-020-2686-x. This work resulted from a collaboration between The Nature Conservancy, World Resources Institute, and 18 other institutions.',
    },
    {
      label: 'Tezlik',
      value: '',
    },
    {
      label: 'Məzmun tarixi',
      value: 'İlk 30 illik təbii meşə reqressivliyi üçün tətbiq edilir.',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        '- Dəyərlər ən yaxşı təxminləri təmsil edir, lakin qeyri-müəyyənlik ehtiva edir. Nəticələrin dəqiqliyi on ölkədə cəmləşmiş model təlimləri üçün məlumatların əldə edilməsinə bağlıdır. Bu məlumat qatı ilə əlaqəli qeyri-müəyyənlik xəritəsini GFW-nin Açıq Məlumat Portalından yükləmək olar.\n- Karbon yığılma dərəcəsi yalnız təbii meşələrin geri qaytarılması üçün tətbiq edilir. Digər aktiv bərpa metodlarına (aqroforestrasiya, plantasiyalar və s.) aid deyil.\n- Karbon yığımı səviyyəsi xəttidir və ilk 30 illik reqrowth üzərində orta hesabla. 30 ildən artıq uzanmaq, ardıcıllığı həddindən artıq hesablamaq olacaq.\n- Qiymətlər yalnız yuxarıda yerləşən canlı biomassada karbon toplanmasını əks etdirir. Torpaq altındakı biomassada, ölü üzvi maddələrdə və torpaq üzvi karbonda yığılma daxil deyil, lakin istəyə görə aşağıda yerləşən karbon toplama xəritəsi mövcuddur.\n- Savannalarda qiymətlər yalnız bu çəmənlik-meşə matroslarının meşəlik hissələrinə aiddir.\n- Bu məlumatlar meşə reqrowth potensialının ətraflı site-level qiymətləndirmələri üçün əvəz deyil.',
    },
    {
      label: 'Lisenziya',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Bu xəritədə meşələrin atmosferdən karbon əldə edə biləcəyi və təbii meşələrin geri çəkilməsinin ilk 30 ili ərzində onu yuxarıda yerləşən canlı biomassada saxlaya biləcəyi sürət göstərilir. Bu, dünyanın minlərlə yerində yerüstü ölçmələri maşın öyrənmə modelində 66 həmyerli ətraf mühit kovariat layları ilə birləşdirərək divar-divar xəritəsi hazırlamaqla yaradılmışdır. Modelə təlim vermək üçün istifadə olunan meşə planı məlumatları nəşr olunmuş ədəbiyyatdan əldə edilir. Bu məlumatlara "Forest Carbon" verilənlər bazasında (ForC, Smithsonian Institute (https://github.com/forc-db) tərəfindən qorunub saxlanılır), eləcə də açıq şəkildə mövcud olan milli meşə inventarlarından georeferans məlumatları tapmaq olar. Bütün dünya üzrə bütün meşə və savanna biomesləri üzərində qiymətlər təxmin edilsə də, Qriscom et al. 2017-də (PNAS) müəyyən edildiyi kimi burada "reforestable" sahəsi ilə süzülür. Bureforestable sahələri bioloji müxtəliflik üçün yem və lif və yaşayış yerlərinin istehsalını qorumaq üçün yerli otlaqların və əkin sahələrinin ərazilərini istisna edir.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Cook-Patton et al. 2020. Carbon accumulation potential from natural forest regrowth in potentially reforestable areas. Accessed through Global Forest Watch 14/02/2025. www.globalforestwatch.org',
  },
};
